import React, { useState, useEffect } from "react";
import "./otpScreen.css";
import deemedLogo from "./resources/logo.png";
import goBackIcon from "./resources/goback.svg";
import axios from "axios";
import OtpInput from "react-otp-input";
import { Alert } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { getUser, setToken } from "../../../auth/authenticate";
import useUser from "../../../context/user/useUser";
import { AUTH_PROVIDER } from "constants/constants";
import { ApiEndpoint } from "config/constants/apiConstants";
import Button from "@mui/material/Button";

function OtpScreen() {
  const navigate = useNavigate();
  const { setUser } = useUser();
  const { state } = useLocation();
  const [otpValue, setOtpValue] = React.useState("");
  const [error, setError] = useState();
  const [success, setSuccess] = useState();

  useEffect(() => {
    if (state == null) {
      navigate("/registration");
    }
  }, []);

  const sendOtp = () => {
    let data = {
      phoneNumber: state?.phoneNumber,
    };
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}user/send-otp`, data)
      .then((response) => {
        // console.log(response);
      })
      .catch();
  };

  const signUp = () => {
    if (state.from === "forgetPassword") {
      const data = {
        email: state.email,
        userTypes: ["PATIENT", "GUARDIAN"],
        code: otpValue,
      };
      axios
        .post(ApiEndpoint.VERIFY_EMAIL_CODE, data)
        .then(() => {
          navigate("/resetpassword", { state: data });
        })
        .catch((err) => {
          setError(err?.response?.data?.message);
        });
    } else {
      const data = {
        otp: otpValue,
        email: state.email,
        password: state.password,
        phoneNumber: state.phoneNumber,
        userType: state.userType,
        name: state.name,
        gender: state.gender,
        // country: state.country,
        timezone:state.timezone,
        district: state.district,
        address: state.address,
        dob: state.dob,
        authProvider: AUTH_PROVIDER.EMAIL_PASSWORD,
      };

      // console.log("Check phone number for Sign Up Process...");
      const sriLankanPhoneRegex =
        /^(0)(?:(11|21|23|24|25|26|27|31|32|33|34|35|36|37|38|41|45|47|51|52|54|55|57|63|65|66|67|81|912)(0|2|3|4|5|7|9)|7(0|1|2|4|5|6|7|8)\d)\d{6}$/;

      // Check if the phone number matches the Sri Lankan format
      if (sriLankanPhoneRegex.exec(state.phoneNumber)) {
        // data.phoneNumber = state.phoneNumber;
        // console.log(
        //   "Sri Lankan phone number. Sign Up Process started through SL Route"
        // );
        axios
          // .post(
          //   `${process.env.REACT_APP_BACKEND_URL}user/patient/sign-up`,
          //   data
          // )
          .post(
            `${process.env.REACT_APP_BACKEND_URL}user/patient/sign-up/srilanka`,
            data
          )
          .then((response) => {
            setSuccess(response.data.message);
            setToken(response.data.data.token);
            setUser(getUser());
            navigate("/patient-dashboard");
          })
          .catch((error) => {
            // JSON.stringify(error);
            console.log(error);
            setError("Something went wrong with Sign Up!");
          });
      } else {
        console.log(
          "Invalid Sri Lankan phone number. Sign Up Process started through International Route"
        );

        axios
          .post(
            `${process.env.REACT_APP_BACKEND_URL}user/patient/sign-up/international`,
            data
          )
          .then((response) => {
            setSuccess(response.data.message);
            setToken(response.data.data.token);
            setUser(getUser());
            navigate("/patient-dashboard");
          })
          .catch((error) => {
            // JSON.stringify(error);
            console.log(error);
            setError("Something went wrong with International Sign Up!");
          });
      }

      // if (state.country === "Sri Lanka") {
      //   console.log("Country detected. Registering as a Sri Lankan");

      // } else {
      //   console.log("Country detected. Registering as an International User");

      // }
    }
  };

  // able to sign up with only necessary details for now or in a emerg. mode.
  // name, dob, gender, email, phone, country, agree to terms // let's see in future
  // const signUpFast = () => {
  // };

  const handleSubmit = () => {
    signUp();
  };

  return (
    <div className="loginBgDoc2">
      <div className="wrapper-center2">
        <div className="row log_wrapper2">
          <div className="text-white log_left2">
            <img className="logo-img2" src={deemedLogo} alt="logo" />
            <h4 className="log_saying2">
              A doctor is not a mechanic.
              <br />
              A car doesn't react with a<br />
              mechanic, but a human <br /> being does.
            </h4>
            <h4 className="log_saying_name2">- Randa Haines</h4>
          </div>
          <div className="log_right2">
            <div className="log_card2">
              <div className="otpBackIcon">
                <div className="goBackIconWrapper">
                  <img src={goBackIcon} alt="" onClick={() => navigate(-1)} />
                </div>
              </div>
              <h3 className="welcome_text2">Enter 4 Digits Code</h3>
              <p className="welcome_des2">
                Enter the 4 digits code that you received to your email/phone
              </p>
              <div className="otp_number_input">
                {/* <OtpInput
                  value={otpValue}
                  onChange={setOtpValue}
                  numInputs={4}
                  separator={<span> </span>}
                  containerStyle={{ marginBottom: 20 }}
                  className="otpTextInput"
                  inputStyle={{
                    // padding: 4,
                    border: "1px solid #DDDDDD",
                    borderRadius: "8px",
                    padding: "12px",
                    marginRight: "10px",
                    marginLeft: "10px",
                    marginTop: "10px",
                    color: "#265ED7",
                    fontSize: 22,
                    fontWeight: "bold",
                  }}
                  isInputNum={true}
                /> */}
                <OtpInput
  value={otpValue}
  onChange={setOtpValue}
  numInputs={4}
   renderInput={(props, i) => (
    <input
      {...props}
      key={i}
      autoFocus={i === 0} // ✅ manually focus first input
      style={{
        width: "3rem",
        height: "3rem",
        textAlign: "center",
        borderRadius: "8px",
        border: "1px solid #ccc",
        fontSize: "1.5rem",
        color: "#265ED7",
        fontWeight: "bold",
      }}
    />
  )}
/>
              </div>

              <div className="button_field margin-bottom-otp-btn">
                {/* <button
                  className="gradientButton"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Continue
                </button> */}
                <Button
                  variant="contained"
                  type="submit"
                  className="payBtn log_submit_btn otp-submit-btn"
                  onClick={(e) => {
                    handleSubmit();
                  }}
                >
                  Continue
                </Button>
              </div>
              {success && <Alert style={{ margin: "8px" }}>{success}</Alert>}
              {error && (
                <Alert severity="error" style={{ margin: "8px" }}>
                  {error}
                </Alert>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export { OtpScreen };
